/// <reference path="api.d.ts" />

namespace API.Client {
    'use strict';

    export interface State {

        /**
         * codigo do estado
         */
        "code"?: string;

        /**
         * nome do estado
         */
        "name"?: string;
    }

}
